import { render, staticRenderFns } from "./account-activity-expander.component.vue?vue&type=template&id=b322ce9a&"
import script from "./account-activity-expander.component.vue?vue&type=script&lang=ts&"
export * from "./account-activity-expander.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports